import METADATA from "./EnvironmentConfigurationEntity.metadata.js";
import { BaseEntity } from "clavis-nxt-components-custdevtm";

class EnvironmentConfigurationEntity extends BaseEntity {
  constructor(
    id,
    configuration,
    environmentCode,
    confValue,
    createdBy,
    createdTs,
    modifiedBy,
    modifiedTs
  ) {
    super();
    this.id = id;
    this.configuration = configuration;
    this.environmentCode = environmentCode;
    this.confValue = confValue;
    this.createdBy = createdBy;
    this.createdTs = createdTs;
    this.modifiedBy = modifiedBy;
    this.modifiedTs = modifiedTs;
  }
}

METADATA.connect(EnvironmentConfigurationEntity);

export { EnvironmentConfigurationEntity };
